import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { PayrollLiabBalanceListColumns } from "../../appconfig/DatatableSetting";
import { getAllDetails, postSingleData } from "../../service/ProductService";
import { GET_REPORT_SUMMARY_LIST, POST_LIAB_BALANCE } from "../../config/ApiConstant";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { useParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";

const PayrollLiabBalance = () => {
  document.title = "Payroll Liab Balance | Nexawage Payroll";
  const toast = useRef<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);

  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [payrollLiabBalanceDialog, setPayrollLiabBalanceDialog] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // filters
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userRole = userData?.roles?.role_name || "";

  // get client id from param for client
  const { id }: any = useParams();
  const clientId = id ? atob(id) : null;

  // useefect for get payroll liab list
  useEffect(() => {
    getPayrollLiabBalanceList();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedYear]);

  // list-payroll-liab-balance
  const getPayrollLiabBalanceList = async () => {
    try {
      // id based on user role
      let idToSend = null;
      let emp_id = null;
      if (userRole === "Client") {
        idToSend = userData?.id;
      } else if (userRole === "Employee") {
        emp_id = userData?.id;
      } else {
        idToSend = clientId;
      }

      const response = await getAllDetails(`${GET_REPORT_SUMMARY_LIST}/${idToSend}?type=payroll_liab_bal&year=${selectedYear}`);

      const data = response;

      if (data) {
        setEmployeeList(data || []);
        setPageLoad(true);
      } else {
        setEmployeeList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // payroll liab balance dialog
  const payrollLiabDialog = async () => {
    setPayrollLiabBalanceDialog(true);
  };

  // submit payroll liab balance dialog
  const submitPayrollLiab = async () => {
    setSubmitLoading(true);
    try {
      // select client id based on user role
      let clientIdToUse = null;
      if (userRole === "User") {
        clientIdToUse = clientId;
      } else if (userRole === "Client") {
        clientIdToUse = userData?.id;
      }

      const response = await postSingleData(`${POST_LIAB_BALANCE}/${clientIdToUse}`);

      if (response) {
        if (!window.cn(response?.data)) {
          const summary_pdf = response?.data;
          setTimeout(() => {
            window.open(summary_pdf, "_blank");
          }, 1000);
        }
        setPageLoad(true);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hidePayrollLiabDialog();
        getPayrollLiabBalanceList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // hide payroll liab dialog
  const hidePayrollLiabDialog = () => {
    setPayrollLiabBalanceDialog(false);
    setSubmitLoading(false);
  };

  // clear all filter
  const clearAll = () => {
    setSelectedYear(currentYear);
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      {/* <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
      </span> */}
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <div className="payrollreport-template">
      {userRole !== "Employee" && (
        <>
          {/* <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="mr-3 p-button-outlined common-p-outline-button" /> */}

          <Calendar
            id="year"
            value={moment(selectedYear, "YYYY").toDate()}
            onChange={(e) => {
              const selectedDate = e.value;
              if (selectedDate instanceof Date) {
                const year = moment(selectedDate).year();
                setSelectedYear(year);
              }
            }}
            view="year"
            dateFormat="yy"
            showIcon
            placeholder="Filter by year"
            className="mr-2 w-15rem"
          />

          <Button className="ml-1 common-primary-button mr-3" icon="pi pi-plus" label="Gen Payroll Liab" onClick={() => payrollLiabDialog()} />
        </>
      )}
    </div>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData?.url) {
      window.open(rowData?.url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  return (
    <>
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={employeeList}
                showGridlines
                responsiveLayout={"scroll"}
                dataKey="id"
                stripedRows
                rows={defaultRowOptions}
                paginator={employeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Payroll Liab Balance"}
                emptyMessage="No Payroll Liab Balance Found"
                removableSort
              >
                {PayrollLiabBalanceListColumns.map((col, i) => {
                  if (col.field === "url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {PayrollLiabBalanceListColumns.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* Generate t4 dialog */}
      <Dialog
        visible={payrollLiabBalanceDialog}
        style={{ width: "600px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Generate Payroll Liab Balance Summary"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hidePayrollLiabDialog} disabled={submitLoading} />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={submitPayrollLiab} loading={submitLoading} />
          </div>
        }
        onHide={hidePayrollLiabDialog}
      >
        <h4 className="mb-4">Do you want to generate Payroll Liab Balance Summary ? </h4>
      </Dialog>
    </>
  );
};
export default PayrollLiabBalance;
